export default __webpack_public_path__ + "fonts/d7d1fba11704b00c7406e61da309bb15.eot";